import React, { useEffect, useState } from 'react';
import { createStructuredSelector } from 'reselect';
import { Trans } from '@lingui/macro';
import { Dispatch } from 'redux';
import { connect } from 'dva';

import SuccessIcon from './private/SuccessIcon/SuccessIcon';
import ErrorIcon from './private/ErrorIcon/ErrorIcon';
import Card from '../Card/Card';
import DeleteChildInfoPopover from '../ConfirmationPopovers/DeleteChildInfoPopover';
import './ChildCard.pcss';
import { addChildModalOpen } from '../../../models/modals';
import { childrenSelector } from '../../../validators/card';
import { childCardStatus } from '../../../constants/iterableTexts';
import { sendCMABusinessError } from '../../../helpers/CMAstats';

interface DispatchFromProps {
  onChildEdit(id: string): void;

  onChildDelete(id: string): void;
}

interface ChildCardProps extends DispatchFromProps {
  id: string;
  children: Record<string, any>;
}

function ChildCard(props: ChildCardProps): JSX.Element {
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const { children, onChildEdit, onChildDelete, id } = props;
  const child = children[id];
  const {
    cardStatus: { isCardCompleted, error, highlight },
    fullName,
    birthdate: { value: birthdateValue },
  } = child;

  useEffect(() => {
    if (!isCardCompleted) {
      sendCMABusinessError('step');
    }
  }, [isCardCompleted]);

  const cardStatusText = !isCardCompleted
    ? childCardStatus[error]
    : childCardStatus.fullyFilled;

  const icon = !isCardCompleted ? (
    <ErrorIcon className="ChildCard__icon" height={14} width={14} />
  ) : (
    <SuccessIcon className="ChildCard__icon" height={14} width={14} />
  );
  const cardError = !isCardCompleted && highlight;

  return (
    <Card className="StepContentBlock ChildCard" error={cardError}>
      <Card.Top>
        <div className="ChildCard__topContent ym-hide-content">
          <span className="ChildCard__name">{fullName}</span>
          <span className="ChildCard__date">{birthdateValue}</span>
        </div>
        <div className="ChildCard__iconMobile">{icon}</div>
        <Card.Button
          className="ChildCard__edit"
          onClick={() => onChildEdit(id)}
        >
          <Trans>Изменить</Trans>
        </Card.Button>
      </Card.Top>
      <Card.Bottom>
        <React.Fragment>
          <div className="ChildCard__infoDesktop">
            {icon}
            <Trans id={cardStatusText} />
          </div>
          <Card.Button
            className="ChildCard__editMobile"
            onClick={() => onChildEdit(id)}
          >
            <Trans>Изменить</Trans>
          </Card.Button>
          <DeleteChildInfoPopover
            wrapperClassName="Form__Popover_wrapper"
            isPopoverOpen={confirmationVisible}
            onPopoverClose={() => setConfirmationVisible(false)}
            onConfirm={() => onChildDelete(id)}
            onCancel={() => setConfirmationVisible(false)}
          >
            <Card.Button
              className="ChildCard__delete"
              onClick={() => setConfirmationVisible(true)}
            >
              <Trans>Удалить</Trans>
            </Card.Button>
          </DeleteChildInfoPopover>
        </React.Fragment>
      </Card.Bottom>
    </Card>
  );
}

const mapStateToProps = createStructuredSelector<any, any>({
  children: childrenSelector,
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchFromProps => ({
  onChildEdit(id) {
    dispatch({
      type: 'children/edit',
      payload: id,
    });
    dispatch(addChildModalOpen(true));
  },
  onChildDelete(id) {
    dispatch({
      type: 'children/delete',
      payload: id,
    });
    dispatch({
      type: 'notHiddenChildren/delete',
      payload: id,
    });
    dispatch(addChildModalOpen(false));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ChildCard);
